import React from 'react';

export default function Heading({level = 'h2', children, className}) {
  const Tag = ({...props}) => React.createElement(level, props, children);

  return <Tag className={className}>{children}</Tag>;
};
